import React from 'react'
import { useLanesSidebar } from './LanesSidebar.logic.js'
import { LanesSidebarView } from './LanesSidebar.view.jsx'

/**
 * Container component for LanesSidebar
 * Connects logic hook with view component
 */
const LanesSidebar = () => {
  const { activeCount, archiveCount, activeHref, archivedHref } =
    useLanesSidebar()

  return (
    <LanesSidebarView
      activeCount={activeCount}
      archiveCount={archiveCount}
      activeHref={activeHref}
      archivedHref={archivedHref}
    />
  )
}

export default LanesSidebar
